// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".centerbox[data-v-0b70a0d0]{font-size:3.733vw}.centerbox h1[data-v-0b70a0d0]{font-size:4.8vw;margin-bottom:2vw}.centerbox p[data-v-0b70a0d0]{margin-bottom:8vw}.centerbox p b[data-v-0b70a0d0]{font-weight:400;color:#eca045}", ""]);
// Exports
module.exports = exports;
